import { createI18n } from 'vue-i18n';
import { getCurrentLanguage } from '@eureka/language-tool';
import { merge } from 'lodash-es';
import { errorCodeMessages } from '@eureka/shared/error-code';

// 本地 import i18n 资源
import trizCn from './messages/cn.json';
import trizEn from './messages/en.json';
import trizJp from './messages/jp.json';
import trizTw from './messages/tw.json';

// 合并各模块的 i18n 消息（使用 shared errorCode）
const messages = {
    cn: merge({}, errorCodeMessages.cn, trizCn),
    en: merge({}, errorCodeMessages.en, trizEn),
    jp: merge({}, errorCodeMessages.jp, trizJp),
    tw: merge({}, errorCodeMessages.tw, trizTw),
};

export function createI18nInstance(locale?: string) {
    locale = locale || getCurrentLanguage();
    return createI18n({
        legacy: false,
        locale,
        fallbackLocale: 'en',
        messages, // 直接使用本地 messages
    });
}

export const i18n = createI18nInstance();
